const getAuth = async () => (await import("@/services/AuthService")).default;

export default defineNuxtPlugin((nuxtApp) => {
  const apiFetch = $fetch.create({
    baseURL: import.meta.env.VITE_API_ENDPOINT,
    async onRequest({ request, options, error }) {
      options.headers.set("Content-Type", "application/vnd.api+json");
      options.headers.set("Accept", "application/vnd.api+json");
      if (import.meta.env.SSR !== true) {
        const auth = await getAuth();
        if (auth.isUserLogged()) {
          options.headers.set("Authorization", `Bearer ${auth.getToken()}`);
        }
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo("/login"));
      }
    },
    async onResponse(res) {
      console.log("res", res.response._data);
    },
  });

  return {
    provide: {
      apiFetch,
    },
  };
});
